import * as TestUtils from './lib/i18n-config-test'
export * from './lib/i18n-config'
export { filteredTranslation } from './lib/filtered-translation'

export { TestUtils }
